export enum ChargingStatusEnum {
  Offline = 0,
  Available = 1,
  Occupied = 2,
  Unavailable = 3,
  Reserved = 4,
  Inoperative = 5
}

export enum OcppStatusEnum {
  Offline = 0,
  Available = 1,
  Preparing = 2,
  Charging = 3,
  SuspendedEVSE = 4,
  SuspendedEV = 5,
  Finishing = 6,
  Unavailable = 7,
  Faulted = 8,
  Reserved = 9
}


export enum ConnectorCommandsEnum {
  DeleteChargePoint,
  Unlock,
  ChangeConnectorAvailability,
  ChangeChargeUnitAvailability,
  RemoteStartTransaction,
  RemoteStopTransaction
}

export enum ChargeStationEnum {
  Available = 1,
  Suspended = 2,
  Terminated = 3,
  Inoperative = 4
}
